<template>
  <div class="accordion">
    <div class="item__box" v-for="(item, i) of list" :key="i" :class="{ 'item__box-active': activeIndex === i }">
      <div
        class="item__title"
        :class="{ 'item__title-active': activeIndex === i }"
        @click="tabChange(i)"
        :style="{
          backgroundImage: `url('${getImagePath3(item.logoUrl)}')`,
          backgroundSize: 'cover',
        }"
      >
        <div class="item__title__text">{{ item.title }}</div>
      </div>
      <div class="item__content" v-show="activeIndex === i" :style="{ backgroundImage: `url('${zttsg_bg}')`, backgroundSize: 'cover', backgroundPosition: 'center' }">
        <el-scrollbar>
          <div
            class="item__content__detail"
            ref="neirongDiv"
            @scroll="divScroll(i)"
          >
            <p v-html="item.description" ref="neirongBox"></p>
          </div>
        </el-scrollbar>
        <div class="zttsg_but">
          <div @click="datebaseinfo(item)">查看详情</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, watch } from "vue";
import { useRouter } from "vue-router";
import scrolldown from "@/assets/newimages/scrolldown.png";
import scrolldown1 from "@/assets/newimages/down.gif";
import zttsg_bg from "@/assets/zttsg_bg.webp";
import { nextTick } from "vue";
const neirongBox = ref(null);
const neirongDiv = ref(null);
const router = useRouter();
const props = defineProps({
  list: {
    type: Array,
    default: () => [],
  },
});
const activeIndex = ref(0);
const dataOpenList = ref([]);

const tabChange = (index) => {
  activeIndex.value = index;
  nextTick(() => {
    console.log(neirongBox);
    // var els = this.$refs.neirongBox;//获取到当前列表的内容元素进行循环
    neirongBox.value.forEach((item, index) => {
      // 获取到每一个元素的文档高度 scrollHeight 这个， 我这里盒子最大高度设置的200，自己设置
      if (item.scrollHeight > 210) {
        props.list[index].isMore = true; //然后将列表里控制的isMore改变，则当前这个列表则会展示展开收起的按钮了
      }
    });
  });
};
watch(
  () => props.list,
  (newVal) => {
    if (newVal && newVal.length > 0) {
      dataOpenList.value = [...newVal]; // 使用浅拷贝避免直接引用
      nextTick(() => {
        // var els = this.$refs.neirongBox;//获取到当前列表的内容元素进行循环
        neirongBox.value.forEach((item, index) => {
          // 获取到每一个元素的文档高度 scrollHeight 这个， 我这里盒子最大高度设置的200，自己设置
          if (item.scrollHeight > 210) {
            props.list[index].isMore = true; //然后将列表里控制的isMore改变，则当前这个列表则会展示展开收起的按钮了
          }
        });
      });
    }
  },
  { immediate: true }, // 立即执行一次
);

const scrollUp = (i) => {
  neirongDiv.value.forEach((item, index) => {
    if (index == i) {
      neirongBox.value.forEach((item1, index) => {
        if (index == i) {
          if (item1.scrollHeight > item.scrollTop + 210) {
            item.scrollTop = item1.scrollHeight - 210;
            props.list[index].isMore = false; //然后将列表里控制的isMore改变，则当前这个列表则会展示展开收起的按钮了
          }
        }
      });
    }
  });
};

const divScroll = (i) => {
  neirongDiv.value.forEach((item, index) => {
    if (index == i) {
      neirongBox.value.forEach((item1, index) => {
        if (index == i) {
          if (item.scrollTop < item1.scrollHeight) {
            props.list[index].isMore = false;
          }
          if (item.scrollTop < item1.scrollHeight - 210) {
            props.list[index].isMore = true;
          }
        }
      });
    }
  });
};

const getImagePath3 = (filePath) => {
  if (!filePath) return ""; // 如果为空，返回空字符串避免错误

  const baseApi = process.env.VUE_APP_BASE_API || "";
  const finalUrl = baseApi + "/ckbop" + filePath;

  return finalUrl;
};
const datebaseinfo = (data) => {
  localStorage.setItem("lastSelectTime", Date.now().toString());
  router.push({
    name: "newDatabaseInfo",
    query: { id: data.id },
  });
};

onMounted(() => {});
</script>

<style lang="scss" scoped>
.accordion {
  position: relative;
  width: 914px;
  height: 334px;
  display: flex;
  color: #fff;
}

.item__box {
  display: flex;
  height: 100%;
  transition: width 0.5s ease;
  overflow: hidden;

  &:not(.item__box-active) {
    width: 116px;
    flex-shrink: 0;
  }

  &.item__box-active {
    width: 554px;
  }

  & + & {
    margin-left: 4px;
  }
}

.item__title {
  width: 116px;
  height: 100%;
  flex-shrink: 0;
  background: #00398e;
  transition: all 0.5s ease;
  cursor: pointer;
  overflow: hidden;
}

.item__title__text {
  writing-mode: vertical-lr;
  font-size: 20px;
  font-weight: 400;
  color: #ffffff;
  width: 116px;
  height: 100%;
  display: flex;
  align-items: center;
  transition: all 0.5s ease;
  padding-top: 32px;
}

.item__content {
  flex: 1;
  min-width: 0;
  padding: 20px;
  position: relative;
  display: flex;
  flex-direction: column;

  .el-scrollbar {
    flex: 1;
  }

  &__detail {
    color: #fff;
    font-size: 14px;
    line-height: 1.6;
  }
}
.item__content__detail {
  width: 100%;
  height: 100%;
  padding-right: 10px;
  text-align: justify;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
}
// /* 初始隐藏滚动条 */
// .item__content__detail::-webkit-scrollbar {
//   width: 6px;
//   height: 6px;
//   display: none; /* Chrome/Safari/Edge 隐藏滚动条 */
// }

// /* 鼠标悬停时显示滚动条 */
// .item__content__detail:hover::-webkit-scrollbar {
//   display: block;
// }

// /* 滚动条轨道 */
// .item__content__detail::-webkit-scrollbar-track {
//   background: rgba(243, 244, 246, 0.8);
//   border-radius: 3px;
// }

// /* 滚动条滑块 */
// .item__content__detail::-webkit-scrollbar-thumb {
//   background-color: rgba(156, 163, 175, 0.6);
//   border-radius: 3px;
//   transition: background-color 0.2s ease;
// }

// /* 滑块交互状态 */
// .item__content__detail::-webkit-scrollbar-thumb:hover {
//   background-color: rgba(107, 114, 128, 0.8);
// }

// .item__content__detail::-webkit-scrollbar-thumb:active {
//   background-color: rgba(75, 85, 99, 0.9);
// }

// /* Firefox 鼠标悬停时显示滚动条 */
// .item__content__detail:hover {
//   scrollbar-width: thin;
//   scrollbar-color: rgba(156, 163, 175, 0.6) rgba(243, 244, 246, 0.8);
// }
.zttsg_but {
  display: flex;
  justify-content: right;
  margin-top: auto;
}
.zttsg_but div {
  width: 78px;
  height: 32px;
 border: 1px solid #6A9CF7;
 font-weight: 400;
font-size: 12px;
color: #1C6BFB;
  text-align: center;
  line-height: 32px;
}
.zttsg_but div:hover {
  // border: none;
  cursor: pointer;
  // background: #1c6bfb;
}

.scrolldown_img {
  width: 16px;
  // height: 32px;
  position: absolute;
  top: 224px;
  left: 260px;
}
.scrolldown_img:hover {
  animation: none;
}

.rotate-x {
  animation: rotateX 5s linear infinite; /* 持续时间5秒，线性速度，无限循环 */
}
.scrollbar-demo-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  margin: 10px;
  text-align: center;
  border-radius: 4px;
  background: var(--el-color-primary-light-9);
  color: var(--el-color-primary);
}

@keyframes rotateX {
  from {
    transform: rotateY(0deg);
  }
  to {
    transform: rotateY(360deg);
  }
}

.item__content .el-scrollbar {
  --el-scrollbar-bg-color: #9ca3af;
  --el-scrollbar-opacity: 0.6;
}
</style>
